
export function doubleStroke(gc: CanvasRenderingContext2D, lineWidth: number, colors?: {
  outer?: string,
  inner?: string,
}) {
  gc.lineWidth = 2.0 * lineWidth
  gc.strokeStyle = colors?.outer ?? 'rgb(255 255 255 / 0.5)'
  gc.stroke()
  gc.lineWidth = lineWidth
  gc.strokeStyle = colors?.inner ?? 'black'
  gc.stroke()
}

export function withTransientState(gc: CanvasRenderingContext2D, draw: () => void) {
    gc.save()
    try {
        draw()
    } finally {
        gc.restore()
    }
}
